import { NetworkRequest } from "./NetworkRequest";
import { NetworkService } from "./NetworkService";

export class NavigationService {
  static async getNavigationSteps() {
    return await NetworkService.request({
      alias: NetworkRequest.NavigationSteps,
      url: "navigation/etapas",
      method: "GET",
    }).then((response) => {
      return response;
    }).catch((reason) => {
      console.log("Error getting navigation steps", reason);
      throw reason;
    })
  }

  static async unlockNextStep(stepName) {
    console.log("Unlocking next step", stepName);
    return await NetworkService.request({
      alias: NetworkRequest.UnlockNextStep,
      url: "navigation/etapas",
      method: "POST",
      data: stepName,
    }).then((response) => {
      return response;
    }).catch((reason) => {
      console.log("Error unlocking next step", reason);
      throw reason;
    })
  }
}